function showHideContent() {
    $( "span.togglemenu" ).on( "click", function() {
        var $historyBlock = $(this).parents(".history-block");
        // Check if the clicked menu item's parent history block is already open
        if (!$historyBlock.hasClass('show')) {
            // Close all other history blocks and menu items
            $(".history-block").removeClass('show');
            $(".togglemenu").removeClass('active');
            $(".menu-content-item").removeClass('show');
            // Open the clicked history block and menu item
            $historyBlock.addClass('show');
            $(this).addClass('active');
            $historyBlock.find(".menu-content-item").addClass('show');
        } else {
            // Close the clicked history block and menu item
            $historyBlock.removeClass('show');
            $(this).removeClass('active');
            $historyBlock.find(".menu-content-item").removeClass('show');
        }
    });
}

showHideContent();
